export default __webpack_public_path__ + "static/media/summachar.9c1b646d.png";